import React, {ReactNode, useCallback, useId} from "react";
import {Tooltip} from "peggirkit";

export type ApplyTooltipProps = {
    "data-tooltip-id": string,
    "data-tooltip-content": string,
};

export type ApplyTooltipFn = (content: string) => ApplyTooltipProps;

interface TooltipContextInterface {
    tooltipId: string,
    applyTooltip: ApplyTooltipFn,
}

const TooltipContext = React.createContext<TooltipContextInterface>({} as TooltipContextInterface);

export const useTooltip = () => {
    return React.useContext<TooltipContextInterface>(TooltipContext);
};

type Props = {
    children: ReactNode,
}

const TooltipProvider = ({children}: Props) => {
    const tooltipId = useId();
    const applyTooltip: ApplyTooltipFn = useCallback((content: string) => ({
        "data-tooltip-id": tooltipId,
        "data-tooltip-content": content,
    }), [tooltipId]);

    return (
        <TooltipContext.Provider value={{tooltipId, applyTooltip}}>
            {children}

            <Tooltip
                id={tooltipId}
                props={{
                    opacity: 1,
                    positionStrategy: "fixed",
                    place: "top",
                    className: "z-[10000]",
                }}
            />
        </TooltipContext.Provider>
    );
};

export default TooltipProvider;